export default __webpack_public_path__ + "media/images/react_icons/google_login-b6c41a1a7aa4ee2c701785db5ad023e0.svg";